export default class ContactServices {
  constructor(element) {
    this.element = element;
    this.tabList = this.element.querySelector('[role="tablist"]');
    this.tabs = Array.from(this.element.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.element.querySelectorAll('[role="tabpanel"]'));

    if (!this.tabList || this.tabs.length === 0 || this.panels.length === 0) {
      return;
    }

    this.tabFocus = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
    if (this.tabFocus === -1) {
      this.tabFocus = 0;
    }

    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));
      tab.addEventListener('keydown', (e) => this.handleKeydown(e, index));
    });
  }

  handleKeydown(e, index) {
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      this.tabs[this.tabFocus].setAttribute('tabindex', '-1');

      if (e.key === 'ArrowRight') {
        this.tabFocus++;
        if (this.tabFocus >= this.tabs.length) this.tabFocus = 0;
      } else if (e.key === 'ArrowLeft') {
        this.tabFocus--;
        if (this.tabFocus < 0) this.tabFocus = this.tabs.length - 1;
      }

      this.updateFocus(this.tabFocus);
    }

    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      this.switchTab(this.tabFocus);
    }

    if (e.key === 'Home') {
      e.preventDefault();
      this.updateFocus(0);
    }
    if (e.key === 'End') {
      e.preventDefault();
      this.updateFocus(this.tabs.length - 1);
    }
  }

  updateFocus(newIndex) {
    this.tabFocus = newIndex;
    this.tabs[this.tabFocus].setAttribute('tabindex', '0');
    this.tabs[this.tabFocus].focus();
  }

  switchTab(index) {
    const targetTab = this.tabs[index];
    const targetPanelId = targetTab.getAttribute('aria-controls');
    const targetPanel = this.element.querySelector(`#${targetPanelId}`);

    this.tabs.forEach(t => {
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
    });
    this.panels.forEach(p => p.setAttribute('hidden', 'true'));

    targetTab.setAttribute('aria-selected', 'true');
    targetTab.setAttribute('tabindex', '0');
    
    if (targetPanel) {
      targetPanel.removeAttribute('hidden');
    }

    this.tabFocus = index;
  }

  static init() {
    const sections = document.querySelectorAll('.contact-services');
    if (!sections.length) return;

    sections.forEach(section => {
      new ContactServices(section);
    });
  }
}